class Zone{
    constructor(id,name,fillColor,strokeColor,polygon,acre=0,plots = []){
        this.id = id;
        this.name = name
        this.fillColor = fillColor;
        this.strokeColor = strokeColor;
        this.polygon = polygon
        this.acre = acre
        this.plots = plots    
    } 
}


export default Zone;